import { defineComponent as _defineComponent } from 'vue'
import NotificationService from '@/core/notification.service';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationSuccess',
  props: {
    title: null,
    message: null
  },
  setup(__props: any) {

const props = __props as {
    title?: string,
    message?: string
}



onMounted(() => {
    NotificationService.success(props.title, props.message);
});

return { __sfc: true,props, NotificationService, onMounted }
}

})